// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__sGK1h","actions":"tab_actions__6ycKu","active":"tab_active__+ihwE","slideIn":"tab_slideIn__t6fUC"};